"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = exports.stringifyDefaultsCommon = exports.PRECISION_SAFE = void 0;
exports.PRECISION_SAFE = 1e21 - 1e5;
exports.stringifyDefaultsCommon = {
    delimiter: ',',
    precision: 3,
    nanString: 'NaN',
    posInfString: '+Infinity',
    negInfString: '-Infinity'
};
function stringify(opts, v) {
    const keys = Object.keys(opts.clampMin);
    let res = '';
    for (const k of keys) {
        const n = Math.min(Math.max(v[k], opts.clampMin[k]), opts.clampMax[k]);
        if (Number.isFinite(n))
            res += n.toFixed(opts.precision);
        else if (Number.isNaN(n))
            res += opts.nanString;
        else if (n > 0.0)
            res += opts.posInfString;
        else
            res += opts.negInfString;
        res += opts.delimiter;
    }
    return res.slice(0, -opts.delimiter.length);
}
exports.stringify = stringify;
